import { render, staticRenderFns } from "./KnowledgeBreadcrumbDropdown.vue?vue&type=template&id=3804aca8&scoped=true&"
import script from "./KnowledgeBreadcrumbDropdown.vue?vue&type=script&lang=js&"
export * from "./KnowledgeBreadcrumbDropdown.vue?vue&type=script&lang=js&"
import style0 from "./KnowledgeBreadcrumbDropdown.vue?vue&type=style&index=0&id=3804aca8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3804aca8",
  null
  
)

export default component.exports